import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CrmAuthConfig, CrmAuthRouteKey, CrmLoginProviderImpl } from 'common-module/auth';
import { CrmUser, CrmUserRoles } from 'common-module/user';

export const requiredRole: CrmUserRoles = 'admin';

export const hasRequiredRole = (roles: Partial<Record<CrmUserRoles, boolean>> | undefined): boolean =>
  !!roles?.[requiredRole];

@Injectable({ providedIn: 'root' })
export class LoginProvider extends CrmLoginProviderImpl {
  protected override handleSuccess(user: CrmUser, route: ActivatedRoute): void {
    if (!hasRequiredRole(user.roles)) {
      this.userService.logout().subscribe();
      this.messageService.error('auth.login.insufficientPermissions');
      return;
    }

    super.handleSuccess(user, route);
  }
}

export const authConfig: CrmAuthConfig = {
  routeGuard: {
    disabledRoutes: [CrmAuthRouteKey.forgottenPassword, CrmAuthRouteKey.resetPassword],
  },
  components: {
    login: {
      showForgottenPassword: false,
      providers: {
        login: LoginProvider,
      },
    },
  },
} as const;
